<template>
  <div class="header-container" :style="{ backgroundImage: backgroundImage }">
    <div class="header-row row1">
      <div class="locale-switcher-container">
        <LocaleSwitcher />
      </div>

      <div class="logo">
        <img :src="logo.default" :srcset="logo.srcset" :sizes="logo.sizes" />
      </div>

      <div class="right">
        <div class="loader-container" v-if="loadingUserData">
          <div class="spinner-border" role="status">
            <span class="visually-hidden">{{ $t(`message.loading`) }}</span>
          </div>
        </div>
        <div
          class="signin-login-container"
          v-else-if="APP_GAR == 'false' && !isUserLogged"
        >
          <router-link class="pill signin" :to="{ name: 'SignUp' }">{{
            $t(`message.signup`)
          }}</router-link>
          <router-link class="pill login" :to="{ name: 'AppLogin' }">{{
            $t(`message.login`)
          }}</router-link>
        </div>
        <div
          class="signin-login-container"
          v-else-if="APP_GAR == 'false' && isUserLogged"
        >
          <router-link class="pill signin" :to="{ name: 'PersonalHome' }">{{
            $t(`message.account.myAccount`)
          }}</router-link>
          <button class="pill login" @click="logoutClick">
            {{ $t(`message.logout`) }}
          </button>
        </div>

        <div class="large-menu">
          <div class="items">
            <router-link :to="{ name: 'TheTeam' }">
              {{ $t(`home.header.links[0]`) }}
            </router-link>
            <router-link :to="{ name: 'AboutIizenglish' }">
              {{ $t(`home.header.links[1]`) }}
            </router-link>
            <router-link
              :to="{ name: 'BlogPostsAboutUs' }"
              v-if="APP_GAR == 'false'"
            >
              {{ $t(`home.header.links[2]`) }}
            </router-link>
            <router-link :to="{ name: 'ContactUs' }">
              {{ $t(`home.header.links[3]`) }}
            </router-link>
          </div>
        </div>

        <StaticPagesMenuToggler class="small-menu"> </StaticPagesMenuToggler>
      </div>
    </div>

    <div class="header-row row2">
      <div class="logo">
        <img :src="logo.default" :srcset="logo.srcset" :sizes="logo.sizes" />
      </div>

      <div class="loader-container" v-if="loadingUserData">
        <div class="spinner-border" role="status">
          <span class="visually-hidden">{{ $t(`message.loading`) }}</span>
        </div>
      </div>
      <div
        class="signin-login-container"
        v-else-if="APP_GAR == 'false' && !isUserLogged"
      >
        <router-link class="pill signin" :to="{ name: 'SignUp' }">{{
          $t(`message.signup`)
        }}</router-link>
        <router-link class="pill login" :to="{ name: 'AppLogin' }">{{
          $t(`message.login`)
        }}</router-link>
      </div>

      <div
        class="signin-login-container"
        v-if="APP_GAR == 'false' && isUserLogged"
      >
        <router-link class="pill signin" :to="{ name: 'PersonalHome' }">{{
          $t(`message.account.myAccount`)
        }}</router-link>
        <button class="pill login" @click="logoutClick">
          {{ $t(`message.logout`) }}
        </button>
      </div>
    </div>

    <div class="header-row row3">
      <i18n-t
        keypath="home.header.titleLineOne"
        tag="div"
        class="title"
      ></i18n-t>
      <i18n-t
        keypath="home.header.titleLineOneBis"
        tag="div"
        class="title"
      ></i18n-t>
      <i18n-t
        keypath="home.header.titleLineTwo"
        tag="div"
        class="title"
      ></i18n-t>
      <i18n-t
        keypath="home.header.titleLineThree"
        tag="div"
        class="title"
      ></i18n-t>
    </div>
  </div>
</template>

<script>
import LogoIizenglishVerticalCouleurPetitFormat from "@/assets/homepage/logo-iizenglish-vertical-couleur-petit-format-1.webp";
import LogoIizenglishVerticalCouleurPetitFormatSmall from "@/assets/homepage/logo-iizenglish-vertical-couleur-petit-format-1-small.webp";
import LogoIizenglishVerticalCouleurPetitFormatMedium from "@/assets/homepage/logo-iizenglish-vertical-couleur-petit-format-1-medium.webp";
import PatternIizenglishHomeHeader from "@/assets/homepage/pattern-iizenglish-home-header.webp";
import StaticPagesMenuToggler from "@/components/homepage/StaticPagesMenuToggler";
import LocaleSwitcher from "@/components/LocaleSwitcher";

export default {
  name: "HomepageHeader",
  components: {
    StaticPagesMenuToggler,
    LocaleSwitcher,
  },
  data() {
    return {
      APP_GAR: import.meta.env.VITE_GAR,
      logo: {
        default: LogoIizenglishVerticalCouleurPetitFormat,
        srcset: `
          ${LogoIizenglishVerticalCouleurPetitFormatSmall} 125w,
          ${LogoIizenglishVerticalCouleurPetitFormatMedium} 188w,
          ${LogoIizenglishVerticalCouleurPetitFormat} 250w
        `,
        sizes: `
          (max-width: 480px) 125px,
          (max-width: 993px) 188px,
          250px
        `,
      },
      backgroundImage: `url(${PatternIizenglishHomeHeader})`,
    };
  },
  methods: {
    logoutClick() {
      this.$store.dispatch("users/logout");
      if (import.meta.env.VITE_GAR == "true") {
        this.$router.push({ name: "HomePage" });
      } else {
        this.$router.push({ name: "AppLogin" });
      }
    },
  },
  computed: {
    loadingUserData() {
      return this.$store.state.users.loadingUserData;
    },
    isUserLogged() {
      return this.$store.getters["users/isLogged"];
    },
  },
};
</script>

<style scoped lang="scss">
.header-container {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: $primaryColorLight;
  box-shadow: inset 0 0 0 1000px rgba(185, 206, 234, 0.8);
  background-size: cover;
  padding: 50px 0px 50px 0px;

  .header-row {
    .locale-switcher-container {
      width: 33%;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .loader-container {
      min-height: 120px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .signin-login-container {
      display: flex;
      flex-direction: column;
      justify-content: center;
      flex-wrap: wrap;

      .pill {
        margin: 5px 0px 5px 0px;
        display: flex;
        align-items: center;
        align-self: center;
        border: 3px solid $tertiaryColor;
        background-color: $tertiaryColor;
        padding: 10px 10px 10px 10px;
        height: 40px;
        border-radius: 20px;
        color: inherit;
        text-decoration: inherit;

        &:hover {
          cursor: pointer;
          background-color: $whiteColor;
        }
      }

      a {
        color: inherit;
        text-decoration: none;
      }
    }
  }

  .row1 {
    display: flex;
    justify-content: space-between;

    .logo {
      width: 33%;
    }

    .right {
      display: flex;
      justify-content: space-around;
      width: 33%;

      .large-menu {
        margin: 0px 20px 0px 20px;

        .items {
          display: flex;
          flex-direction: column;
          div {
            font-weight: bold;
            margin: 10px 0px 15px 0px;
            white-space: nowrap;

            &:hover {
              cursor: pointer;
              color: $secondaryColor;
            }
          }
          a {
            font-weight: bold;
            margin: 10px 0px 15px 0px;
            white-space: nowrap;
            color: inherit;
            text-decoration: none;

            &:hover {
              cursor: pointer;
              color: $secondaryColor;
            }
          }
        }
      }

      .small-menu {
        margin: 0px 40px 0px 20px;
      }
    }
  }

  .row3 {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px;
    margin: 50px 0px 0px 0px;

    .title {
      font-family: "Averia Sans Libre", sans-serif;
      text-transform: uppercase;
      font-size: 20px;
      font-weight: bold;
      margin: 0px 10px 0px 10px;
    }
  }

  @media screen and (max-width: 768px) {
    .row3 {
      gap: 20px;
      margin: 40px 0px 0px 0px;

      .title {
        font-size: 20px;
      }
    }
  }

  @media screen and (max-width: 992px) {
    .large-menu {
      display: none;
    }

    .row1 {
      .logo {
        display: none;
      }

      .signin-login-container {
        display: none;
      }

      .loader-container {
        display: none;
      }

      .locale-switcher-container {
        margin: 0px 20px 0px 40px;
      }
    }

    .row2 {
      margin-top: 20px;

      .signin-login-container {
        margin-top: 20px;
      }
    }

    .row3 {
      gap: 20px;
    }
  }

  @media screen and (min-width: 993px) {
    .small-menu {
      display: none;
    }

    .row2 {
      display: none;
    }
  }
}
</style>
